'use client';
import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import 'classnames';
import '../../server-components/Table/components/HeaderCell.module.scss.js';
import '../../server-components/layout/Flex/Flex.js';
import '../../server-components/layout/Row/Row.module.scss.js';
import '../../server-components/layout/Stack/Stack.js';
import '../../server-components/layout/Box/Box.js';
import '../../server-components/icons/ActivityIcon.js';
import '../../server-components/icons/ArrowDownIcon.js';
import '../../server-components/icons/ArrowDownRightCircleIcon.js';
import '../../server-components/icons/ArrowLeftAlignIcon.js';
import '../../server-components/icons/ArrowLeftIcon.js';
import '../../server-components/icons/ArrowRightAlignIcon.js';
import '../../server-components/icons/ArrowRightIcon.js';
import '../../server-components/icons/ArrowUpIcon.js';
import '../../server-components/icons/ArrowUpRightCircleIcon.js';
import '../../server-components/icons/ArrowsAngleExpandIcon.js';
import '../../server-components/icons/BankIcon.js';
import CheckIcon from '../../server-components/icons/CheckIcon.js';
import '../../server-components/icons/ChevronDownIcon.js';
import '../../server-components/icons/ChevronRightIcon.js';
import '../../server-components/icons/ChevronUpIcon.js';
import CopyIcon from '../../server-components/icons/CopyIcon.js';
import '../../server-components/icons/CrossIcon.js';
import '../../server-components/icons/DaiIcon.js';
import '../../server-components/icons/DownSortIcon.js';
import '../../server-components/icons/ExclamationTriangleIcon.js';
import '../../server-components/icons/ExpandKpiIcon.js';
import '../../server-components/icons/EyeIcon.js';
import '../../server-components/icons/EyeSlashIcon.js';
import '../../server-components/icons/Grid1x2Icon.js';
import '../../server-components/icons/InfoCircleIcon.js';
import '../../server-components/icons/ListIcon.js';
import '../../server-components/icons/LockIcon.js';
import '../../server-components/icons/MediumIcon.js';
import '../../server-components/icons/MoonIcon.js';
import '../../server-components/icons/PiggyBankIcon.js';
import '../../server-components/icons/QuestionMarkCircleIcon.js';
import '../../server-components/icons/ShieldIcon.js';
import '../../server-components/icons/SunIcon.js';
import '../../server-components/icons/UpSortIcon.js';
import '../../server-components/icons/XIcon.js';
import '../../server-components/Table/Table.module.scss.js';
import '../../server-components/Table/components/TableRow.module.scss.js';
import '../../server-components/Table/components/Pagination.module.scss.js';
import '../../server-components/Text/Text.js';
import '../../server-components/Table/components/TableCell/TableCell.module.scss.js';
import '../../server-components/Card/Card.module.scss.js';
import '../../server-components/List/List.module.scss.js';
import '../../server-components/ErrorBox/ErrorBox.module.scss.js';
import '../../server-components/InfoBox/InfoBox.module.scss.js';
import '../../server-components/KpiCard/KpiCard.module.scss.js';
import '../../server-components/TrendValue/TrendValue.module.scss.js';
import '../../server-components/Modal/Modal.module.scss.js';
import '../ThemeProvider.js';
import '../Tabs/Tabs.module.scss.js';
import '../ThemeModeSelector/ThemeModeSelector.module.scss.js';
import '../ExpandableCard/ExpandableCard.module.scss.js';
import '../ExpandableKpiCard/ExpandableKpiCard.module.scss.js';
import styles from './CopyButton.module.scss.js';
import 'luxon';
import '../WalletAddress/WalletAddress.module.scss.js';
import 'ethereum-blockies-base64';
import '../filters/TextSearchFilter/TextSearchFilter.module.scss.js';
import '@blockanalitica/ui';
import '../sidebars/FixedSidebar/components/MobileTopNavBar/MobileTopNavbar.module.scss.js';
import '../sidebars/FixedSidebar/components/Sidebar/Sidebar.module.scss.js';
import '../sidebars/FixedSidebar/FixedSidebar.module.scss.js';
import '../sidebars/CollapsableSidebar/CollapsableSidebar.module.scss.js';
import '../FormattedCurrency/FormattedCurrency.js';
import '../FormattedPercentage/FormattedPercentage.js';
import '../CurrencyValue/CurrencyValue.module.scss.js';
import '../PercentageValue/PercentageValue.module.scss.js';
import '../DisplaySwitch/DisplaySwitch.module.scss.js';
import '../Tooltip/Tooltip.js';
import 'lodash';
import '../charts/ChartJS.js';
import '../charts/components/ChartKpis/ChartKpis.module.scss.js';
import '../charts/components/ChartSingleValueIndicator/ChartSingleValueIndicator.module.scss.js';
import '../charts/BarChart/BarChart.module.scss.js';
import '../charts/LineChart/LineChart.module.scss.js';
import '../charts/AreaChart/AreaChart.module.scss.js';
import 'randomcolor';
import 'd3';
import '../Checkbox/Checkbox.module.scss.js';
import '../../server-components/Badge/Badge.module.scss.js';
import '../../server-components/HeatmapActivity/HeatmapActivity.module.scss.js';
import '../../server-components/Switch/Switch.module.scss.js';
import '../../server-components/Select/Select.module.scss.js';
import '../../server-components/pictograms/EthPictogram.js';
import '../../server-components/pictograms/EtherScanPictogram.js';
import '../../server-components/pictograms/DebankPictogram.js';
import '../../server-components/pictograms/ZapperPictogram.js';
import '../../server-components/pictograms/DaiPictogram.js';
import 'react-loading-skeleton';

function CopyButton({ textToCopy, size }) {
    const [copied, setCopied] = useState(false);
    const handleCopyClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (navigator.clipboard) {
            navigator.clipboard.writeText(textToCopy).then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 10000);
            });
        }
    };
    return (jsx("div", { className: styles.button, onClick: handleCopyClick, children: copied ? jsx(CheckIcon, { size: size }) : jsx(CopyIcon, { size: size }) }));
}

export { CopyButton as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29weUJ1dHRvbi5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvY2xpZW50LWNvbXBvbmVudHMvQ29weUJ1dHRvbi9Db3B5QnV0dG9uLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyIndXNlIGNsaWVudCc7XG5cbmltcG9ydCB7IHVzZVN0YXRlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ29weUljb24sIENoZWNrSWNvbiB9IGZyb20gJy4uLy4uL3NlcnZlci1jb21wb25lbnRzJztcbmltcG9ydCBzdHlsZXMgZnJvbSAnLi9Db3B5QnV0dG9uLm1vZHVsZS5zY3NzJztcblxudHlwZSBDb3B5QnV0dG9uUHJvcHMgPSB7XG4gIHRleHRUb0NvcHk6IHN0cmluZztcbiAgc2l6ZT86IG51bWJlcjtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIENvcHlCdXR0b24oeyB0ZXh0VG9Db3B5LCBzaXplIH06IENvcHlCdXR0b25Qcm9wcykge1xuICBjb25zdCBbY29waWVkLCBzZXRDb3BpZWRdID0gdXNlU3RhdGU8Ym9vbGVhbj4oZmFsc2UpO1xuXG4gIGNvbnN0IGhhbmRsZUNvcHlDbGljayA9IChlOiBSZWFjdC5Nb3VzZUV2ZW50PEhUTUxEaXZFbGVtZW50PikgPT4ge1xuICAgIGUucHJldmVudERlZmF1bHQoKTtcbiAgICBlLnN0b3BQcm9wYWdhdGlvbigpO1xuXG4gICAgaWYgKG5hdmlnYXRvci5jbGlwYm9hcmQpIHtcbiAgICAgIG5hdmlnYXRvci5jbGlwYm9hcmQud3JpdGVUZXh0KHRleHRUb0NvcHkpLnRoZW4oKCkgPT4ge1xuICAgICAgICBzZXRDb3BpZWQodHJ1ZSk7XG5cbiAgICAgICAgc2V0VGltZW91dCgoKSA9PiB7XG4gICAgICAgICAgc2V0Q29waWVkKGZhbHNlKTtcbiAgICAgICAgfSwgMTAwMDApO1xuICAgICAgfSk7XG4gICAgfVxuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPGRpdiBjbGFzc05hbWU9e3N0eWxlcy5idXR0b259IG9uQ2xpY2s9e2hhbmRsZUNvcHlDbGlja30+XG4gICAgICB7Y29waWVkID8gPENoZWNrSWNvbiBzaXplPXtzaXplfSAvPiA6IDxDb3B5SWNvbiBzaXplPXtzaXplfSAvPn1cbiAgICA8L2Rpdj5cbiAgKTtcbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQVd3Qjs7QUFHdEI7OztBQUlFOzs7Ozs7QUFPRTs7QUFFSjtBQUVBO0FBS0Y7OyJ9
